export enum StudentFiltersEnum {
  TOPPERS = "toppers",
  LAGARDS = "laggards",
  LEAST_PRACTICED = "leastEffort",
  MOST_EFFORT = "mostEffort",
}

export enum ChapterFiltersEnum {
  DEFAULT = "default",
  RECENT = "recent",
  IMPORTANT = "important",
  STRONGEST = "strongest",
  WEAKEST = "weakest",
}

export enum DashboardTabsEnum {
  REPORTS = "Reports",
  RECOMMENDATIONS = "Recommendations",
}

export enum BatchTestAnalysisTabsEnum {
  STUDENT_WISE_MARKS = "Student Wise Marks",
  PREFORMANCE_SUMMARY = "Performance Summary",
}

export enum StudentsProgressReportTabsEnum {
  CHAPTER_WISE_ANALYSIS = "Chapter Wise Analysis",
  INSTITUTE_TEST_REPORT = "Institute Test Report",
}

export enum PdfReportTypeEnum {
  LEAD_SCHOOL_WEEKLY = "LeadSchoolWeekly",
  LEAD_SCHOOL_MONTHLY = "LeadSchoolMonthly",
  LEAD_STUDENT_PROGRESS = "LeadStudentProgress",
  LEAD_SERIES_SCHOOL_MONTHLY = "LeadSeriesSchoolMonthly",
  LEAD_SERIES_STUDENT_MONTHLY = "LeadSeriesStudentMonthly",
  LEAD_SCHOOL_EXAM_RESULTS = "LeadSchoolExamResults",
  LEAD_STUDENT_EXAM_RESULTS = "LeadStudentExamResults",
  LEAD_SCHOOL_TEST_RESULTS = "LeadSchoolTestResults",
  LEAD_STUDENT_TEST_RESULTS = "LeadStudentTestResults",
  OFFLINE_TEST_SUBJECTWISE_RESULTS = "OfflineTestSubjectWiseResults",
}

export enum AffiliationReportTabEnum {
  STUDENT_WISE = "Student-wise",
  QUESTION_WISE = "Question-wise",
}

export enum StudentActivityTypeEnum {
  SELF_PRACTICE = 5,
  SELF_TEST = 6,
  INSTITUTE_TEST = 7,
  ASSIGNMENT = 8,
}

export enum SubjectiveQuestionSortTypeEnum {
  QUESTIONS = 1,
  STUDENTS = 2,
}

export enum SubjectiveEvaluationStatusEnum {
  PENDING = 1,
  AI_EVALUATED = 2,
  EVALUATED = 3,
}

export enum ProgressStatusEnum {
  ON_SCHEDULE = "On Schedule",
  BEHIND_SCHEDULE = "Behind Schedule",
  AHEAD_OF_SCHEDULE = "Ahead of Schedule",
}
